// This file was automatically generated from util.format.html.
// Please don't edit this file by hand.

goog.provide('el8.template.util.format');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.util.format.apply = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.formatting && opt_data.formatting.length) {
    output.append(soy.$$escapeHtml(opt_data.text.substring(0,opt_data.formatting[0].offsets[0])));
    var fList1068 = opt_data.formatting;
    var fListLen1068 = fList1068.length;
    for (var fIndex1068 = 0; fIndex1068 < fListLen1068; fIndex1068++) {
      var fData1068 = fList1068[fIndex1068];
      output.append((! (fIndex1068 == 0)) ? soy.$$escapeHtml(opt_data.text.substring(opt_data.formatting[fIndex1068 - 1].offsets[1],fData1068.offsets[0])) : '');
      el8.template.util.format.decorate({decoration: fData1068.decoration, text: opt_data.text.substring(fData1068.offsets[0],fData1068.offsets[1])}, output);
    }
    output.append(soy.$$escapeHtml(opt_data.text.substring(opt_data.formatting[opt_data.formatting.length - 1].offsets[1],opt_data.text.length)));
  } else {
    output.append((opt_data.text) ? soy.$$escapeHtml(opt_data.text) : '');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.util.format.decorate = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  switch (opt_data.decoration) {
    case 'abnormal_labs':
      output.append('<span class="summaryAbnormalLab">', soy.$$escapeHtml(opt_data.text), '</span>');
      break;
    case 'tag_item':
      output.append('<span class="el8TagItem mr5">', soy.$$escapeHtml(opt_data.text), '</span><span style="font-size: 0">&nbsp;</span>');
      break;
    case 'left_indent':
      output.append('<span class="el8LeftIndent">', soy.$$escapeHtml(opt_data.text), '</span>');
      break;
    case 'light_app_color':
      output.append('<span class="el8AppColor">', soy.$$escapeHtml(opt_data.text), '</span>');
      break;
    default:
      output.append(soy.$$escapeHtml(opt_data.text));
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.util.format.commaSeparate = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.list && opt_data.list.length) {
    var itemList1104 = opt_data.list;
    var itemListLen1104 = itemList1104.length;
    for (var itemIndex1104 = 0; itemIndex1104 < itemListLen1104; itemIndex1104++) {
      var itemData1104 = itemList1104[itemIndex1104];
      output.append(soy.$$escapeHtml(itemData1104), (! (itemIndex1104 == itemListLen1104 - 1)) ? ', ' : '');
    }
  }
  if (!opt_sb) return output.toString();
};
